/**
 * kqxs-ajax.js
 *
 * Xử lý tương tác Calendar ↔ KQXS block trên trang chủ.
 *
 * Khi người dùng click vào một ngày trên flatpickr calendar:
 *  - Ngày quá khứ / hôm nay → gọi AJAX kqxs_load_block cho từng block
 *  - Ngày tương lai → ẩn lottery blocks, gọi AJAX kqxs_load_schedule hiển thị lịch mở thưởng
 *
 * Requires: wp_vars.ajax_url (localized từ functions.php)
 *           window.__kqxsInitLotteryDisplay (exposed từ index.js)
 *           window.__kqxsLoadAllBlocks được expose ra để _calendar_board.js gọi
 */

(function () {
    'use strict';

    const BLOCKS = ['mien-nam', 'mien-bac', 'mien-trung'];

    const CLASS_PREFIX_MAP = {
        'mien-nam':   'southern-lottery',
        'mien-bac':   'northern-lottery',
        'mien-trung': 'central-lottery',
    };

    /**
     * Parse dd/mm/yyyy → Date (00:00:00)
     */
    function parseDate(str) {
        if (!str) return null;
        var parts = str.split('/');
        if (parts.length !== 3) return null;
        var d = new Date(+parts[2], +parts[1] - 1, +parts[0]);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    /**
     * Kiểm tra date string có phải ngày tương lai không.
     */
    function isFutureDate(dateStr) {
        if (!dateStr) return false;
        var selected = parseDate(dateStr);
        if (!selected) return false;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        return selected.getTime() > today.getTime();
    }

    /**
     * Gọi AJAX để lấy HTML của một block kqxs theo date.
     * @param {string} block  'mien-nam' | 'mien-bac' | 'mien-trung'
     * @param {string} date   'dd/mm/yyyy' hoặc '' để lấy kết quả mới nhất
     */
    async function loadBlock(block, date) {
        const el = document.querySelector('[data-kqxs-block="' + block + '"]');
        if (!el) return;

        // Hiển thị loading: mờ đi, chặn click
        el.style.opacity      = '0.5';
        el.style.pointerEvents = 'none';

        try {
            const body = new URLSearchParams({
                action: 'kqxs_load_block',
                block:  block,
                date:   date,
            });

            const res = await fetch(window.wp_vars.ajax_url, {
                method:  'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body:    body.toString(),
            });

            const json = await res.json();

            if (json.success && json.data && json.data.html) {
                const tmp = document.createElement('div');
                tmp.innerHTML = json.data.html.trim();
                const newEl = tmp.firstElementChild;

                if (newEl) {
                    el.replaceWith(newEl);

                    // Re-init lotteryDisplay (2 số / 3 số / ball highlight)
                    const classPrefix = CLASS_PREFIX_MAP[block];
                    if (classPrefix && typeof window.__kqxsInitLotteryDisplay === 'function') {
                        window.__kqxsInitLotteryDisplay(classPrefix);
                    }
                }
            } else {
                // Thất bại → khôi phục trạng thái
                el.style.opacity      = '';
                el.style.pointerEvents = '';
            }
        } catch (err) {
            console.error('[kqxs-ajax] loadBlock error:', block, err);
            el.style.opacity      = '';
            el.style.pointerEvents = '';
        }
    }

    /**
     * Hiển thị / ẩn các lottery block sections.
     */
    function toggleLotteryBlocks(show) {
        BLOCKS.forEach(function (block) {
            var el = document.querySelector('[data-kqxs-block="' + block + '"]');
            if (el) el.style.display = show ? '' : 'none';
        });
        // Ẩn/hiện computer lottery + ads giữa các block
        var computerEl = document.querySelector('[data-kqxs-block="dien-toan"]');
        if (computerEl) computerEl.style.display = show ? '' : 'none';

        // Ẩn/hiện các ads nằm giữa blocks (quảng cáo horizontal)
        var mainSide = document.querySelector('.main-side');
        if (mainSide) {
            var ads = mainSide.querySelectorAll('.ads-full-width, .bg-white.h-\\[95px\\]');
            ads.forEach(function (ad) { ad.style.display = show ? '' : 'none'; });
        }
    }

    /**
     * Load schedule (lịch mở thưởng) cho ngày tương lai.
     */
    async function loadSchedule(dateStr) {
        var container = document.getElementById('schedule-lottery-container');
        if (!container) return;

        // Ẩn lottery blocks, hiện container
        toggleLotteryBlocks(false);
        container.style.display = '';
        container.style.opacity = '0.5';

        try {
            var body = new URLSearchParams({
                action: 'kqxs_load_schedule',
                date:   dateStr,
            });

            var res = await fetch(window.wp_vars.ajax_url, {
                method:  'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body:    body.toString(),
            });

            var json = await res.json();

            if (json.success && json.data && json.data.html) {
                container.innerHTML = json.data.html;
            } else {
                container.innerHTML = '<p style="text-align:center;padding:2rem;">Không có dữ liệu lịch mở thưởng.</p>';
            }
        } catch (err) {
            console.error('[kqxs-ajax] loadSchedule error:', err);
            container.innerHTML = '<p style="text-align:center;padding:2rem;">Lỗi tải dữ liệu.</p>';
        }

        container.style.opacity = '';
    }

    /**
     * Ẩn schedule, hiện lại lottery blocks.
     */
    function hideSchedule() {
        var container = document.getElementById('schedule-lottery-container');
        if (container) {
            container.style.display = 'none';
            container.innerHTML = '';
        }
        toggleLotteryBlocks(true);
    }

    /**
     * Load tất cả các block với cùng một date.
     * Nếu là ngày tương lai → hiển thị schedule thay vì KQXS.
     * @param {string} date 'dd/mm/yyyy' hoặc '' để lấy kết quả mới nhất
     */
    function loadAllBlocks(date) {
        if (isFutureDate(date)) {
            loadSchedule(date);
        } else {
            hideSchedule();
            BLOCKS.forEach(function (block) {
                loadBlock(block, date);
            });
        }
    }

    // Expose ra window để _calendar_board.js (flatpickr onChange) gọi được
    window.__kqxsLoadAllBlocks = loadAllBlocks;

})();
